import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./features/store/store";
import {Provider} from "react-redux";
import {ThemeProvider} from "@material-ui/styles";
import {Theme} from "./theme";
import GlobalStyle from "./theme/GlobalStyle";

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle />
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);
